import { render, staticRenderFns } from "./perizinan.vue?vue&type=template&id=7d54a378&"
import script from "./perizinan.vue?vue&type=script&lang=js&"
export * from "./perizinan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports